import {Field} from 'formik';
import {Container} from "@mantine/core";
import {
    FormikNumberInput,
    FormikRadioGroup,
    FormikSelect,
    FormikTextInput,
    PlatformFieldset
} from "@flexinet/ui-components";
import {
    MeterAggregation,
    MeterGrain,
    MeterPurpose,
    MeterResetPolicy
} from "../types.ts";
import {FormikList} from "../../../components/FormikList";

const enumOptions = (e: Record<string, string>) =>
    Object.values(e).map(value => ({label: value, value}));

export const FormComponent = () => {

    return (
        <Container>
            <PlatformFieldset legend={'Meter'}>
                <Field
                    name='name'
                    label='Display Name'
                    description='Please enter name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='meterCode'
                    label='Meter Code'
                    description='Producer-facing code, lowercase dot-separated (e.g. email.sent)'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='aggregation'
                    label='Aggregation'
                    description='How usage is aggregated'
                    component={FormikSelect}
                    data={enumOptions(MeterAggregation)}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='grain'
                    label='Grain'
                    description='Natural time bucket'
                    component={FormikSelect}
                    data={enumOptions(MeterGrain)}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='unit'
                    label='Unit'
                    description='Display unit (e.g. messages, domains, gb_hours)'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='resetPolicy'
                    label='Reset Policy'
                    description='Whether the running value resets at period start'
                    component={FormikSelect}
                    data={enumOptions(MeterResetPolicy)}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='purpose'
                    label='Purpose'
                    description='Billable, audit-only, or both'
                    component={FormikSelect}
                    data={enumOptions(MeterPurpose)}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Timing'}>

                <Field
                    name='watermarkDelayMinutes'
                    label='Watermark Delay (minutes)'
                    description='How long to wait past period end before the initial close'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='latenessWindowMinutes'
                    label='Lateness Window (minutes)'
                    description='Bounded window for post-close corrections'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Meter Dimensions'}>

                <Field
                    name='dimensions'
                    label='Dimensions'
                    description='Please enter dimensions'
                    component={FormikList}
                    getRowElements={() => [{
                        name: 'name',
                        placeholder: 'Display Name',
                        component: FormikTextInput,
                    }, {
                        name: 'apiKey',
                        placeholder: 'API Key',
                        component: FormikTextInput,
                    }]}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Status'}>

                <Field
                    name='status'
                    label='Status'
                    description='Please enter status'
                    component={FormikRadioGroup}
                    data={[{
                        value: 'DRAFT',
                        label: 'Draft',
                    }, {
                        value: 'ACTIVE',
                        label: 'Active',
                    }, {
                        value: 'DEPRECATED',
                        label: 'Deprecated',
                    }, {
                        value: 'RETIRED',
                        label: 'Retired',
                    }]}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>

        </Container>
    );
};
